import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { FormGroup, Radio, Table } from 'react-bootstrap'

import BillingGroupName from 'internal-components/src/components/Client/BillingGroupName'
import PaymentTokenDetails from 'internal-components/src/containers/Payment/TokenDetails'
import UserDetails from 'internal-components/src/containers/User/UserDetails'
import { UserRecord } from 'internal-components/src/records'

import './ClientSelector.css'

const radioGroup = 'client-selector-group'

export default function ClientSelector({
  billingGroups,
  selectClient,
  selectedBillingGroupId,
  selectedClientId,
  user,
}) {
  const newClient = !selectedBillingGroupId && !selectedClientId
  const handleChange = (clientId, billingGroupId) => () =>
    selectClient(clientId, billingGroupId)

  const canSubmit = (user ? user.relationships : []).reduce((acc, rel) => {
    acc[rel.client_id] =
      rel.roles.filter(role => role === 'ADMIN' || role === 'OWNER').size > 0

    return acc
  }, {})

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <FormGroup>
      <Table bordered hover className="client-selector">
        <thead>
          <tr>
            <th />
            <th>Client Name</th>
            <th>Primary Contact</th>
            <th>Stored Credit Card</th>
          </tr>
        </thead>

        {billingGroups
          .map((groups, client) => (
            <tbody key={client.id} className="client-boundary">
              <tr>
                <th colSpan={4}>{client.name}</th>
              </tr>
              {!canSubmit[client.id] && (
                <tr>
                  <td colSpan={4}>
                    <p>
                      You do not have authorisation to add a new service to this
                      client.
                    </p>
                  </td>
                </tr>
              )}

              {canSubmit[client.id] &&
                groups
                  .map(group => (
                    <tr
                      key={group.id}
                      onClick={handleChange(client.id, group.id)}
                    >
                      <td>
                        <Radio
                          key={group.id}
                          checked={selectedBillingGroupId === group.id}
                          name={radioGroup}
                          onChange={handleChange(client.id, group.id)}
                        />
                      </td>
                      <td>
                        <BillingGroupName
                          billingGroup={group}
                          client={client}
                        />

                        {group.serviceCount > 0 && (
                          <small className="text-muted">
                            <br />
                            {group.serviceCount} active services.
                          </small>
                        )}
                      </td>
                      <td>
                        <UserDetails userId={group.contact} />

                        {group.email_overrides.size > 0 && (
                          <small className="text-muted">
                            <br />
                            Invoices go to: {group.email_overrides.join(', ')}
                          </small>
                        )}
                      </td>
                      <td>
                        {group.payment_token && (
                          <PaymentTokenDetails uuid={group.payment_token} />
                        )}

                        {!group.token_required &&
                          !group.payment_token && (
                            <small className="text-info">
                              A credit card is not required for this group.
                            </small>
                          )}
                      </td>
                    </tr>
                  ))
                  .toArray()}

              {canSubmit[client.id] && (
                <tr onClick={handleChange(client.id, null)}>
                  <td>
                    <Radio
                      checked={
                        !selectedBillingGroupId &&
                        client.id === selectedClientId
                      }
                      name={radioGroup}
                      onChange={handleChange(client.id, null)}
                    />
                  </td>
                  <td colSpan={3}>
                    Create new Billing Group in <em>{client.name}</em>
                    <br />
                    <small className="text-muted">
                      Select this option to create a billing separation for this
                      service inside the {client.name} account.
                    </small>
                  </td>
                </tr>
              )}
            </tbody>
          ))
          .toIndexedSeq()}

        <tbody>
          <tr>
            <td colSpan={4} style={{ height: '0.25em' }} />
          </tr>
          <tr onClick={handleChange(null, null)}>
            <td>
              <Radio
                checked={newClient}
                name={radioGroup}
                onChange={handleChange(null, null)}
              />
            </td>
            <td colSpan={3}>
              Create a new client
              <br />
              <small className="text-muted">
                Select this option to create an entirely new client account in
                our systems. You will be added as the only authorised contact
                for this account.
              </small>
            </td>
          </tr>
        </tbody>
      </Table>
    </FormGroup>
  )
}

ClientSelector.propTypes = {
  billingGroups: Ipt.orderedMap.isRequired,
  selectClient: Pt.func.isRequired,
  selectedBillingGroupId: Pt.number,
  selectedClientId: Pt.number,
  user: Pt.instanceOf(UserRecord),
}



// WEBPACK FOOTER //
// ./src/components/Signup/ClientSelector.jsx